export default {
    withoutPrintAct: {
        title: 'Подтверждаете выдачу заказа без печати акта?',
        confirm: 'Да',
        cancel: 'Нет',
    },
};